// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._13cFcnVV2w53joYB-2wMnr{-moz-column-count:1;column-count:1;list-style:none}.-xJkQuBqtWsA8tDdkRsf9{line-height:2rem}", "",{"version":3,"sources":["webpack://./resources/js/components/FormComponents/BlCheckboxGroup/styles.module.scss"],"names":[],"mappings":"AAAA,yBACI,mBAAA,CAAA,cAAA,CACA,eACJ,CAEA,uBACI,gBACJ","sourcesContent":[".checkbox_group {\n    column-count: 1;\n    list-style: none;\n}\n\n.checkbox {\n    line-height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox_group": "_13cFcnVV2w53joYB-2wMnr",
	"checkbox": "-xJkQuBqtWsA8tDdkRsf9"
};
export default ___CSS_LOADER_EXPORT___;
